module.exports = __webpack_public_path__ + "img/json_temp.6ddcfeb7.png";